import { render, staticRenderFns } from "./PrintSingleFeedback.vue?vue&type=template&id=c295c41a&"
import script from "./PrintSingleFeedback.vue?vue&type=script&lang=js&"
export * from "./PrintSingleFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c295c41a')) {
      api.createRecord('c295c41a', component.options)
    } else {
      api.reload('c295c41a', component.options)
    }
    module.hot.accept("./PrintSingleFeedback.vue?vue&type=template&id=c295c41a&", function () {
      api.rerender('c295c41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print/single-feedback/PrintSingleFeedback.vue"
export default component.exports